// 保宏
const map = {
  // 保宏事务
  taxesVerification: () => import('@/views/bhtransaction/TaxesVerification'),
  // 保宏库存管理
  pushLogList: () => import('@/views/bhStockControl/pushLogList'), // 推送日志列表
  recordsGoodsList: () => import('@/views/bhStockControl/RecordsGoodsList'), // 备案货品列表
  ASNList: () => import('@/views/bhStockControl/ASNList'), // ASN列表
  ASNWarehousingDetailList: () =>
    import('@/views/bhStockControl/ASNWarehousingDetailList'), // ASN入库明细列表
  reExitList: () => import('@/views/bhStockControl/ReExitList'), // 复出境列表
  recordsGoodsDetail: () => import('@/views/bhStockControl/RecordsGoodsDetail'), // 备案货品详情
  createASN: () => import('@/views/bhStockControl/CreateASN'), // 新建ASN
  editASN: () => import('@/views/bhStockControl/EditASN'), // 查看ASN
  createReExit: () => import('@/views/bhStockControl/CreateReExit'), // 新建复出境
  editReExit: () => import('@/views/bhStockControl/EditReExit'), // 查看复出境
  stockInChangesList: () => import('@/views/bhStockControl/StockInChangesList'), // 库存变动列表
  viewStockInChangesDetail: () =>
    import('@/views/bhStockControl/ViewStockInChangesDetail'), // 查看库存变动
  otherOutStockList: () => import('@/views/bhStockControl/otherOutStockList'), // 其他出库列表
  viewOtherOutStockDetail: () =>
    import('@/views/bhStockControl/ViewOtherOutStockDetail'), // 查看其他出库
  reExitOutStockList: () => import('@/views/bhStockControl/ReExitOutStockList'), // 复出境出库列表
  viewReExitOutStockDetail: () =>
    import('@/views/bhStockControl/ViewReExitOutStockDetail'), // 查看复出境出库
  reExitOutStockDetailList: () =>
    import('@/views/bhStockControl/ReExitOutStockDetailList'), // 复出境出库明细列表
  borrowOutStockList: () => import('@/views/bhStockControl/borrowOutStockList'), // 借用出库列表
  viewBorrowOutStockDetail: () =>
    import('@/views/bhStockControl/ViewBorrowOutStockDetail'), // 查看借用出库
  saleOutStockList: () => import('@/views/bhStockControl/SaleOutStockList'), // 销售出库列表
  viewSaleOutStockDetail: () =>
    import('@/views/bhStockControl/ViewSaleOutStockDetail'), // 查看销售出库
  getWmsStockSkuList: () => import('@/views/bhStockControl/GetWmsStockSkuList'), // 出入库明细表
  getWmsStockPatchSkuList: () =>
    import('@/views/bhStockControl/GetWmsStockPatchSkuList'), // 出入库批次明细表
  getWmsSkuStockList: () => import('@/views/bhStockControl/GetWmsSkuStockList'), // 货品库存列表
  getWmsSkuPatchList: () => import('@/views/bhStockControl/GetWmsSkuPatchList'), // 货品批次明细详情
  getWmsValidPeriodList: () =>
    import('@/views/bhStockControl/GetWmsValidPeriodList'), // 有效期库存详情
  getWmsSkuList: () => import('@/views/bhStockControl/GetWmsSkuList'), // 货品批次管理
  recordedGoodsSummaryList: () =>
    import('@/views/bhStockControl/recordedGoodsSummaryList') // 备案货品汇总列表
}

export default map
